
export default function autoLogout() {
  if($('body').data('ec-logged-in') === true) {

    let secondsSinceLastActivity = 0;
    let secondsSinceLastUpdate = 0;
    const maxInactivity = (60 * 5);
    const intTime = 30;


    setInterval(function () {
      secondsSinceLastActivity = secondsSinceLastActivity + intTime;
      secondsSinceLastUpdate = secondsSinceLastUpdate + intTime;
      if (secondsSinceLastActivity > maxInactivity) {
        location.href = 'logout';
      }
    }, parseInt(intTime * 1000));

    const activity = () => {
      secondsSinceLastActivity = 0;
      if(secondsSinceLastUpdate >= 60) {
        secondsSinceLastUpdate = 0;
        updateActivity();
      }
    };

    const updateActivity = () => {
      $.ajax({
        url: window.location.origin + '/wp-admin/admin-ajax.php',
        type: "GET",
        data: {
          'action': 'set_last_activity'
        },
        dataType: "json",
        success: function (res) {
        },
        error: function() {
        }
      });
    }

    const activityEvents = [
      'mousedown', 'mousemove', 'keydown',
      'scroll', 'touchstart'
    ];

    activityEvents.forEach(function (eventName) {
      document.addEventListener(eventName, activity, true);
    });
  }
}
